import "./Connect.module.css";
import Header from "@/reusable_sections/Header";
import StartAConversation from "./sections/StartAConversation";
import CommonInquiries from "./sections/CommonInquiries";
import Footer from "@/reusable_sections/Footer";
export default function ConnectPage() {
  return <div>
      <Header />
      <StartAConversation />
      <CommonInquiries />
      <Footer />
    </div>;
}